// extracted by mini-css-extract-plugin
export var blue = "bw_fC";
export var button = "bw_b7";
export var label = "bw_cs";
export var orange = "bw_fD";
export var white = "bw_fF";